import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp, _dec15, _dec16, _dec17, _dec18, _dec19, _class4, _class5, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _temp2;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "cc026H7EPZCxYVBFGj8057I", "Bg0", undefined);

import { _decorator, Component, Node, Prefab, Vec2, NodePool, instantiate, v3, Color, Texture2D, color, MeshRenderer } from 'cc';
import { E_EventType, E_GameState, E_LayerGroup } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var DecorateBg = (_dec = ccclass("DecorateBg"), _dec2 = property([Prefab]), _dec3 = property(Node), _dec4 = property(Vec2), _dec5 = property(Vec2), _dec6 = property([Vec2]), _dec7 = property([Vec2]), _dec8 = property(Vec2), _dec9 = property(Boolean), _dec10 = property({
  type: Texture2D,
  visible: function visible() {
    return this.isHill == true;
  }
}), _dec11 = property({
  type: Color,
  visible: function visible() {
    return this.isHill == true;
  }
}), _dec12 = property({
  type: Color,
  visible: function visible() {
    return this.isHill == true;
  }
}), _dec13 = property({
  type: Color,
  visible: function visible() {
    return this.isHill == true;
  }
}), _dec14 = property({
  type: Color,
  visible: function visible() {
    return this.isHill == true;
  }
}), _dec(_class = (_class2 = (_temp = function DecorateBg() {
  _initializerDefineProperty(this, "pfb", _descriptor, this);

  _initializerDefineProperty(this, "n_p", _descriptor2, this);

  _initializerDefineProperty(this, "zRange", _descriptor3, this);

  _initializerDefineProperty(this, "yRange", _descriptor4, this);

  _initializerDefineProperty(this, "rotateRange", _descriptor5, this);

  _initializerDefineProperty(this, "scaleRange", _descriptor6, this);

  _initializerDefineProperty(this, "numRange", _descriptor7, this);

  _initializerDefineProperty(this, "isHill", _descriptor8, this);

  _initializerDefineProperty(this, "tex_hill", _descriptor9, this);

  _initializerDefineProperty(this, "baseColor", _descriptor10, this);

  _initializerDefineProperty(this, "ShadeColor1", _descriptor11, this);

  _initializerDefineProperty(this, "ShadeColor2", _descriptor12, this);

  _initializerDefineProperty(this, "Emissive", _descriptor13, this);
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "pfb", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_p", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "zRange", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "yRange", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "rotateRange", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "scaleRange", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "numRange", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "isHill", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "tex_hill", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "baseColor", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "ShadeColor1", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "ShadeColor2", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "Emissive", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
export var Bg0 = (_dec15 = ccclass('Bg0'), _dec16 = property(Node), _dec17 = property([Texture2D]), _dec18 = property([Texture2D]), _dec19 = property({
  type: [DecorateBg]
}), _dec15(_class4 = (_class5 = (_temp2 = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Bg0, _Component);

  function Bg0() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_bg", _descriptor14, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "texBgArr", _descriptor15, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "texHillArr", _descriptor16, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "decorateArr", _descriptor17, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_pool", new Map());

    _defineProperty(_assertThisInitialized(_this), "_x_cur", 0);

    _defineProperty(_assertThisInitialized(_this), "_baseCArr", []);

    _defineProperty(_assertThisInitialized(_this), "_shadeColor1Arr", []);

    _defineProperty(_assertThisInitialized(_this), "_shadeColor2Arr", []);

    _defineProperty(_assertThisInitialized(_this), "_specularArr", []);

    _defineProperty(_assertThisInitialized(_this), "_emissiveArr", []);

    _defineProperty(_assertThisInitialized(_this), "_bgInfo", []);

    _defineProperty(_assertThisInitialized(_this), "_tgIndex", 0);

    return _this;
  }

  var _proto = Bg0.prototype;

  _proto.onLoad = function onLoad() {
    for (var i = 0; i < this.decorateArr.length; i++) {
      for (var k = 0; k < this.decorateArr[i].pfb.length; k++) {
        var pool = new NodePool(this.decorateArr[i].pfb[k]._uuid);

        this._pool.set(this.decorateArr[i].pfb[k]._uuid, pool);
      }
    }

    this.pushC(this._baseCArr, ["#6B7466", "#7A7A7A", "#E3E94F"]);
    this.pushC(this._shadeColor1Arr, ["#568149D6", "#4783DDD6", "#E6952ECB"]);
    this.pushC(this._shadeColor2Arr, ["#797979", "#00A8A8", "#807C7C"]);
    this.pushC(this._specularArr, ["#4A4B4B2D", "#FFFFFF32", "#4A4B4B2D"]);
    this.pushC(this._emissiveArr, ["#1CFF00", "#0087AA", "#0C0A00"]);

    for (var _i = 0; _i < 3; _i++) {
      this._bgInfo.push({
        bgIndex: _i,
        hillIndex: _i
      });
    }

    for (var _i2 = 3; _i2 < 5; _i2++) {
      this._bgInfo.push({
        bgIndex: _i2,
        hillIndex: -1
      });
    }
  };

  _proto.pushC = function pushC(arr, hexArr) {
    var c_base = color();

    for (var i = 0; i < hexArr.length; i++) {
      Color.fromHEX(c_base, hexArr[i]);
      arr.push(c_base);
    }
  };

  _proto.onDestroy = function onDestroy() {
    this._pool.forEach(function (curPool) {
      curPool.clear();
    });

    this._pool.clear();

    this.removeEventListener();
  };

  _proto.start = function start() {
    // [3]
    this.init();
  };

  _proto.addEventListenr = function addEventListenr() {
    /**游戏重置 */
    App.EventMgr.addEventLintener(E_EventType.Game_Reset, this.handle_gameReset, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.handle_gameReset = function handle_gameReset() {
    this.init();
  };

  _proto.init = function init() {
    this._tgIndex = Math.floor(App.DataMgr.tollgateLv / 5);
    this._tgIndex %= 5;
    this._x_cur = 0;
    this.n_bg.getComponent(MeshRenderer).materials[0].setProperty("baseColorMap", this.texBgArr[this._tgIndex]); // @property([Texture2D])
    // texHillArr: Texture2D[] = [];

    this.generateDecorate();
  };

  _proto.generateDecorate = function generateDecorate() {
    var i = 0;
    if (this._tgIndex >= 3) i = 1;

    for (; i < this.decorateArr.length; i++) {
      var allPfb = this.decorateArr[i].pfb;

      for (var k = 0; k < allPfb.length; k++) {
        var num = 1; // App.NumHandler.round_int(this.decorateArr[i].numRange.y, this.decorateArr[i].numRange.x);

        for (var m = 0; m < num; m++) {
          var n_cur = this._pool.get(allPfb[k]._uuid).get();

          if (!n_cur) {
            n_cur = instantiate(allPfb[k]);
            n_cur.layer = E_LayerGroup.BG;
          }

          n_cur.parent = this.decorateArr[i].n_p;

          if (n_cur.name.indexOf("shan01") != -1) {
            var mat = n_cur.children[0].getComponent(MeshRenderer).materials[0];
            mat.setProperty("baseColor", this._baseCArr[this._tgIndex]);
            mat.setProperty("shadeColor1", this._shadeColor1Arr[this._tgIndex]);
            mat.setProperty("shadeColor2", this._shadeColor2Arr[this._tgIndex]);
            mat.setProperty("specular", this._specularArr[this._tgIndex]);
            mat.setProperty("emissive", this._emissiveArr[this._tgIndex]);
            mat.setProperty("baseColorMap", this.texHillArr[this._tgIndex]);
          } //坐标


          var yRange = this.decorateArr[i].yRange;
          var zRange = this.decorateArr[i].zRange;
          var x = App.NumHandler.round_float(10, -5);
          var y = App.NumHandler.round_float(yRange.y - yRange.x, yRange.x);
          var z = App.NumHandler.round_float(zRange.y - zRange.x, zRange.x); //旋转

          var x_angle = 0;
          var y_angle = 0;
          var z_angle = 0;
          var info_angle = this.decorateArr[i].rotateRange;

          for (var _i3 = 0; _i3 < info_angle.length; _i3++) {
            if (_i3 == 0) {
              x_angle = App.NumHandler.round_float(info_angle[_i3].y - info_angle[_i3].x, info_angle[_i3].x);
            } else if (_i3 == 1) {
              y_angle = App.NumHandler.round_float(info_angle[_i3].y - info_angle[_i3].x, info_angle[_i3].x);
            } else if (_i3 == 2) {
              z_angle = App.NumHandler.round_float(info_angle[_i3].y - info_angle[_i3].x, info_angle[_i3].x);
              break;
            }
          } //缩放


          var x_scale = n_cur.scale.x;
          var y_scale = n_cur.scale.y;
          var z_scale = n_cur.scale.z;
          var info_scale = this.decorateArr[i].scaleRange;

          for (var _i4 = 0; _i4 < info_scale.length; _i4++) {
            if (_i4 == 0) {
              x_scale = App.NumHandler.round_float(info_scale[_i4].y - info_scale[_i4].x, info_scale[_i4].x);
            } else if (_i4 == 1) {
              y_scale = App.NumHandler.round_float(info_scale[_i4].y - info_scale[_i4].x, info_scale[_i4].x);
            } else if (_i4 == 2) {
              z_scale = App.NumHandler.round_float(info_scale[_i4].y - info_scale[_i4].x, info_scale[_i4].x);
            }
          }

          n_cur.setPosition(v3(this._x_cur + x, y, z));
          n_cur.eulerAngles = v3(x_angle, y_angle, z_angle);
          n_cur.scale = v3(x_scale, y_scale, z_scale);
          App.GameCtrl.addAutoRecyle(n_cur);
        }
      }
    }

    this._x_cur += App.DataMgr.vSize_game.width + 5;
  };

  _proto.colorFromHex = function colorFromHex(hex) {
    var c_aim = color();
    Color.fromHEX(c_aim, hex);
    return c_aim;
  };

  _proto.update = function update(deltaTime) {
    if (App.GameCtrl.gameState != E_GameState.Gaming) return;

    if (App.GameCtrl.cam_game.node.position.x + App.DataMgr.vSize_game.width >= this._x_cur) {
      this.generateDecorate();
    }
  };

  return Bg0;
}(Component), _temp2), (_descriptor14 = _applyDecoratedDescriptor(_class5.prototype, "n_bg", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class5.prototype, "texBgArr", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class5.prototype, "texHillArr", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class5.prototype, "decorateArr", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class5)) || _class4);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();